// src/data/heroData.ts
import { Analytics, FlashOn, TrendingUp, AccessTime } from '@mui/icons-material';
import type { SvgIconTypeMap } from '@mui/material';
import type { OverridableComponent } from '@mui/material/OverridableComponent';

export interface StatItem {
  value: string;
  label: string;
  icon: OverridableComponent<SvgIconTypeMap<{}, "svg">>;
  color: string;
}

export const heroStats = [
  {
    value: '+10K',
    label: 'Datos analizados',
    icon: Analytics,
    color: '#3b82f6'
  },
  {
    value: '60ms',
    label: 'Respuesta',
    icon: FlashOn,
    color: '#f59e0b'
  },
  {
    value: '81%',
    label: 'Precisión',
    icon: TrendingUp,
    color: '#059669'
  },
  {
    value: '24/7',
    label: 'Monitorización',
    icon: AccessTime,
    color: '#db2777'
  }
] as const; // ← as const para type safety

export const heroContent = {
  badgeText: 'Tecnología Avanzada',
  title: 'Teledetección en Medios Acuáticos',
  description: 'Empresa especializada en sensores ambientales y análisis de calidad del agua. Integramos tecnología avanzada y conocimiento científico para soluciones de monitorización.'
} as const;

export const heroSettings = {
  imageUrl: '/img/resized/faro-costa-atardecer_opt.webp'
} as const;

// Opcional: Si quieres types más estrictos
export type HeroStat = typeof heroStats[number];
export type HeroContent = typeof heroContent;